import type { PxQuestion } from './types';

/**
 * Submit-time validation for the PX Connect Schadenbericht (UCPWO-378).
 *
 * Returns the keys of mandatory questions that are missing an answer. Only the
 * questions passed in are checked — callers pass the *visible* questions
 * (see `collectVisibleQuestions`) so hidden branches never block submit.
 */
export const validatePxReport = (visibleQuestions: PxQuestion[]): Set<string> => {
    const invalid = new Set<string>();
    for (const question of visibleQuestions) {
        if (question.isMandatory && !question.answers.some((answer) => answer.isSelected)) {
            invalid.add(question.key);
        }
    }
    return invalid;
};
